const pageNameKey = "thingsHubDragAndDrop";

export const thingsHubDragAndDropEn = {
  [pageNameKey]: {
    activateDragModeText: "Activate drag mode",
    deactivateDragModeText: "Deactivate drag mode",
    toggleDragModeAltText: "Toggle drag mode",
  },
};

export const thingsHubDragAndDropPtBr = {
  [pageNameKey]: {
    activateDragModeText: "Ativar modo de arrastar",
    deactivateDragModeText: "Desativar modo de arrastar",
    toggleDragModeAltText: "Alternar modo de arrastar",
  },
};

export const thingsHubDragAndDropDe = {
  [pageNameKey]: {
    activateDragModeText: "Drag-Modus aktivieren",
    deactivateDragModeText: "Drag-Modus deaktivieren",
    toggleDragModeAltText: "Drag-Modus wechseln",
  },
};

export const thingsHubDragAndDropZhHans = {
  [pageNameKey]: {
    activateDragModeText: "激活拖动模式",
    deactivateDragModeText: "停用拖动模式",
    toggleDragModeAltText: "切换拖动模式",
  },
};

export const thingsHubDragAndDropIt = {
  [pageNameKey]: {
    activateDragModeText: "Attiva modalità trascinamento",
    deactivateDragModeText: "Disattiva modalità trascinamento",
    toggleDragModeAltText: "Cambia modalità trascinamento",
  },
};

export const thingsHubDragAndDropEs = {
  [pageNameKey]: {
    activateDragModeText: "Activar modo de arrastre",
    deactivateDragModeText: "Desactivar el modo de arrastre",
    toggleDragModeAltText: "Activar modo de arrastre",
  },
};

export const thingsHubDragAndDropNl = {
  [pageNameKey]: {
    activateDragModeText: "Drag-modus inschakelen",
    deactivateDragModeText: "Drag-modus uitschakelen",
    toggleDragModeAltText: "Drag-modus wisselen",
  },
};

export const thingsHubDragAndDropTr = {
  [pageNameKey]: {
    activateDragModeText: "Sürükleme modunu etkinleştir",
    deactivateDragModeText: "Sürükleme modunu devre dışı bırak",
    toggleDragModeAltText: "Sürükleme modunu değiştir",
  },
};
